import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Button = (props) => {
	const buttonClassName = classnames({
		"c-button": true,
		[props.className]: true,
		"c-button--selected": props.selected,
		"c-button--disabled": props.disabled,
		"c-button--small": props.small
	});

	const content = props.children ? props.children : props.text;

	let buttonProps = {
		type: "button",
		autoFocus: props.autoFocus,
		className: buttonClassName,
		disabled: props.disabled,
		onClick: props.onClick,
		selected: props.selected,
		onMouseOver: props.onMouseOver,
		onMouseOut: props.onMouseOut,
		title: props.title
	};

	if (props.style) {
		buttonProps.style = props.style;
	}

	return (
		<button {...buttonProps}>
			{content}
		</button>);
};

Button.propTypes = {
	onClick: PropTypes.func,
	text: PropTypes.string.isRequired,
	className: PropTypes.string,
	title: PropTypes.string,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	autoFocus: PropTypes.bool,
	style: PropTypes.object,
	small: PropTypes.bool,
	onMouseOver: PropTypes.func,
	onMouseOut: PropTypes.func
};

export default Button;
